<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否可接受在無塵室穿戴無塵服及手套工作
                  <p class="en-text">Can accept wear clean suit and gloves at work inside clean room</p>
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCondition.CanWorkAtCleanRoom"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCondition.CanWorkAtCleanRoom"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6"></div>

        <div class="col-md-12" v-if="!workCondition.CanWorkAtCleanRoom">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: !workCondition.CanWorkAtCleanRoom ? true : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!workCondition.CanWorkAtCleanRoom" class="mark">
                  *
                </span>
                <span :style="{ color: fontColor }">
                  說明
                  <span class="en-text">Explain</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="workCondition.CanWorkAtCleanRoomDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否可接受使用顯微鏡之工作
                  <p class="en-text">Can accept using microscope at work</p>
                </span>
              </div>

              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCondition.CanUseMicroscope"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCondition.CanUseMicroscope"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-6"></div>

        <div class="col-md-12" v-if="!workCondition.CanUseMicroscope">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: !workCondition.CanUseMicroscope ? true : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!workCondition.CanUseMicroscope" class="mark">
                  *
                </span>
                <span :style="{ color: fontColor }">
                  說明
                  <span class="en-text">Explain</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="workCondition.CanUseMicroscopeDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否可配合單位工具及產品搬運
                  <p class="en-text">Can cooperate with Unit work tools and delivery of product</p>
                </span>
              </div>

              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCondition.CanCarryObjects"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCondition.CanCarryObjects"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-6"></div>

        <div class="col-md-12" v-if="!workCondition.CanCarryObjects">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: !workCondition.CanCarryObjects ? true : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!workCondition.CanCarryObjects" class="mark">
                  *
                </span>
                <span :style="{ color: fontColor }">
                  說明
                  <span class="en-text">Explain</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="workCondition.CanCarryObjectsDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否可接受長時間定點性/走動性久站
                  <p class="en-text">Can accept long time fix point/ walking/ long standing</p>
                </span>
              </div>

              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCondition.CanStandLongTime"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCondition.CanStandLongTime"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-6"></div>

        <div class="col-md-12" v-if="!workCondition.CanStandLongTime">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: !workCondition.CanStandLongTime ? true : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!workCondition.CanStandLongTime" class="mark">
                  *
                </span>
                <span :style="{ color: fontColor }">
                  說明
                  <span class="en-text">Explain</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="workCondition.CanStandLongTimeDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否可接受接觸化學藥品工作
                  <p class="en-text">Work can touch chemicals</p>
                </span>
              </div>

              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCondition.CanWorkWithChemicals"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCondition.CanWorkWithChemicals"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-6"></div>

        <div class="col-md-12" v-if="!workCondition.CanWorkWithChemicals">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: !workCondition.CanWorkWithChemicals ? true : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!workCondition.CanWorkWithChemicals" class="mark">
                  *
                </span>
                <span :style="{ color: fontColor }">
                  說明
                  <span class="en-text">Explain</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="workCondition.CanWorkWithChemicalsDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否可接受英文介面機台操作
                  <p class="en-text">Work can accept machine English interface</p>
                </span>
              </div>

              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCondition.CanOperateMachineInEnglish"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCondition.CanOperateMachineInEnglish"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-md-6"></div>

        <div class="col-md-12" v-if="!workCondition.CanOperateMachineInEnglish">
          <div class="field">
            <ValidationProvider
              :rules="{
                required: !workCondition.CanOperateMachineInEnglish
                  ? true
                  : false,
              }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span
                  v-if="!workCondition.CanOperateMachineInEnglish"
                  class="mark"
                >
                  *
                </span>
                <span :style="{ color: fontColor }">
                  說明
                  <span class="en-text">Explain</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="3"
                  maxlength="200"
                  show-word-limit
                  v-model="workCondition.CanOperateMachineInEnglishDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  過去兩年內是否請過長假
                  <p class="en-text">For the past 2 years if had request long term leave</p>
                </span>
              </div>

              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="workCondition.HasLongTermVacation"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="workCondition.HasLongTermVacation"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
          </div>
        </div>
        <div class="col-md-6"></div>

        <div class="col-md-12">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                說明
                <span class="en-text">Explain</span>
              </span>
            </div>
            <div class="field-value">
              <el-input
                class="w-100"
                type="textarea"
                :rows="3"
                maxlength="200"
                show-word-limit
                v-model="workCondition.HasLongTermVacationDesc"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="edit-btn-wrap">
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveWorkCondition)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseDLWorkCondition",
  
  data() {
    return {
      workCondition: {},

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 工作條件
    saveWorkCondition() {
      this.$api.dl
        .putWorkCondition(this.source, {
          ...this.workCondition,
          UserId: this.source === 'resume' ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "工作條件儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === 'resume') {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getWorkCondition();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 工作條件
    getWorkCondition() {
      const candidate = this.source === "resume" ? this.$cookies.get("candidateId") : this.matchId;
      this.updateLoading(true);
      this.$api.dl
        .getWorkCondition(this.source, candidate)
        .then((response) => {
          if (response.status === 200) {
            this.workCondition = response.data;
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getWorkCondition();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
